var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#FFD5B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.612 28.12-1.656-1.699a1.237 1.237 0 0 1-.002-1.733 1.203 1.203 0 0 1 1.712-.019l3.729 3.717a1.206 1.206 0 0 1 0 1.71l-3.729 3.719a1.211 1.211 0 0 1-1.712-.002 1.154 1.154 0 0 1 .002-1.665l1.656-1.606h-1.561c-2.254 0-5.128-2.87-8.456-6.085-2.734-2.642-6.137-6.022-7.818-6.022h-2.316a1.21 1.21 0 0 1 0-2.422h2.316c2.66 0 5.983 3.304 9.501 6.703 2.32 2.241 5.499 5.404 6.773 5.404h1.561zm3.782-9.948a1.212 1.212 0 0 0 0-1.715l-3.728-3.722a1.214 1.214 0 0 0-.855-.36c-.31 0-.621.108-.857.345a1.18 1.18 0 0 0 .001 1.687l1.657 1.607h-1.561c-1.755 0-3.447 1.306-5.957 3.652a1.252 1.252 0 0 0-.057 1.745c.457.488 1.223.49 1.71.034 1.648-1.54 3.309-3.01 4.304-3.01h1.561l-1.657 1.699a1.265 1.265 0 0 0-.001 1.756 1.21 1.21 0 0 0 1.712.002l3.728-3.72zM10.25 29.332c0 .667.542 1.21 1.21 1.21h2.317c1.971 0 3.953-1.473 6.32-3.622a1.26 1.26 0 0 0 .083-1.75 1.2 1.2 0 0 0-.897-.386c-.29 0-.582.128-.813.338-1.515 1.375-3.417 2.998-4.693 2.998h-2.316c-.669 0-1.211.543-1.211 1.211z",
    fill: "#FE5C04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAction);
export default __webpack_public_path__ + "static/media/homeAction.8c46a7d54141629885f777e610738412.svg";
export { ForwardRef as ReactComponent };